import React from 'react';
import PropTypes from 'prop-types';

import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";
import YesNo from "components/Display/YesNo";

import Checkbox from "jsx/elements/inputs/Checkbox";
import TransactionKey from "../Display/TransactionKey";
import CostCalculatedFor from "../Display/CostCalculatedFor";
import RecordNumber from "../Display/RecordNumber";


class PrincipalResultTable extends React.Component {

  state = {
  };

  constructor(props){
    super(props);
  }

  render() {
    if (!this.props.data.legs){
      return (
        <div/>
      );
    }

    console.log("this.props.data",this.props.data );
    let principals = this.props.data.legs[0].principals;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="11" className="text-left">
              <span className="calc-setting-table-header">Höfuðstólar.&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </th>
          </tr>
          <tr>
            <th className="text-center">G.nr.</th>
            <th className="text-left">Færslulykill</th>
            <th className="text-center">Útgáfudagur</th>
            <th className="text-center">Gjalddagi</th>
            <th className="text-center">Reikna dráttavexti</th>
            <th className="text-center">Drv.dagur</th>            
            <th className="text-right">Upphæð</th>
            <th className="text-right">Drv.</th>
            <th className="text-right">Hst.Drv.</th>
            <th className="text-right">VSK</th>
            <th className="text-right">FTS</th>
          </tr>
          </thead>
          <tbody>
          {principals.map((item,i) => {           
              let cName = "row-current-normal";
              let isOdd = item.paymentNumber % 2 === 1;
              if (isOdd){
                cName = "row-current-highlight";
              }
            return(
                <tr key={i + "inner"} className={cName}>
                  <td className="text-left"><RecordNumber data={item.paymentNumber}/></td>
                  <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                  <td className="text-right"><Date data={item.issueDate}/></td>
                  <td className="text-right"><Date data={item.dueDate}/></td>
                  <td className="text-right"><YesNo data={item.calculatePenaltyInterest}/></td>                  
                  <td className="text-right"><Date data={item.finalDueDate}/></td>                                    
                  <td className="text-right"><Amount data={item.amount}/></td>
                  <td className="text-right"><Amount data={item.penaltyInterestAmount}/></td>
                  <td className="text-right"><Amount data={item.capitalizedPenaltyInterestAmount}/></td>
                  <td className="text-right"><Amount data={item.vatAmount}/></td>
                  <td className="text-right"><Amount data={item.capitalGainsTaxAmount}/></td>
                </tr>)            
          })}

          </tbody>
        </table>
      </div>
    );
  }
}

PrincipalResultTable.propTypes = {
  data: PropTypes.object,
};



export default PrincipalResultTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/PrincipalResultTable.js